export const replaceHalfSpace = (term: string) => {
  return term.replace(/\u200C/g, ' ');
};
